import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-28347bac"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "d-photos-header"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "d-photos-header__title" }, "My Files", -1))
const _hoisted_3 = { class: "d-layout-switcher" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Drop some files here ")
const _hoisted_5 = {
  key: 0,
  class: "drop-zone"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "drop-zone__body" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "drop-zone__icon icon icon-download" }),
  /*#__PURE__*/_createElementVNode("span", { class: "drop-zone__text" }, "Drop some files here")
], -1))
const _hoisted_7 = [
  _hoisted_6
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_header_upload_progress = _resolveComponent("app-header-upload-progress")!
  const _component_app_drop_zone = _resolveComponent("app-drop-zone")!
  const _component_item_mixed = _resolveComponent("item-mixed")!
  const _component_app_no_message = _resolveComponent("app-no-message")!
  const _component_refresh_pull = _resolveComponent("refresh-pull")!

  return (_openBlock(), _createElementBlock("div", null, [
    (!_ctx.mainStore.isMobile)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _hoisted_2,
          (_ctx.mainStore.uploadInfos.length)
            ? (_openBlock(), _createBlock(_component_app_header_upload_progress, {
                key: 0,
                uploadInfo: _ctx.mainStore.getUploadInfo
              }, null, 8, ["uploadInfo"]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("span", {
              class: _normalizeClass(["d-layout-switcher__btn icon", !_ctx.driveStore.isGridFolderView ? 'active icon-list-view-2-active' : 'icon-list-view-2']),
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.driveStore.isGridFolderView = false))
            }, null, 2),
            _createElementVNode("span", {
              class: _normalizeClass(["d-layout-switcher__btn icon", _ctx.driveStore.isGridFolderView ? 'active icon-tiles-2-active' : 'icon-tiles-2']),
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.driveStore.isGridFolderView = true))
            }, null, 2)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.mainStore.isMobile)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "scroll",
          ref: "scroller",
          onScroll: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.handleScroll && _ctx.handleScroll(...args)))
        }, [
          _createVNode(_component_refresh_pull, {
            modelValue: _ctx.loadingPull,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.loadingPull) = $event)),
            onRefresh: _ctx.onRefresh,
            successText: _ctx.successText,
            pullingText: _ctx.pullingText,
            loosingText: _ctx.loosingText,
            loadingText: _ctx.loadingText,
            disabled: !!_ctx.driveStore.search || _ctx.isPageLoading
          }, {
            default: _withCtx(() => [
              (_ctx.isOverDropZone)
                ? (_openBlock(), _createBlock(_component_app_drop_zone, {
                    key: 0,
                    "indents-height": 141,
                    class: "drop-zone-box"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_4
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_item_mixed, {
                onViewFile: _ctx.openFile,
                mixedList: _ctx.mixedData,
                column: !_ctx.driveStore.isGridFolderView,
                skeleton: _ctx.dataLoading,
                selector: _ctx.driveStore.isMixedSelector,
                loading: _ctx.isPageLoading
              }, null, 8, ["onViewFile", "mixedList", "column", "skeleton", "selector", "loading"]),
              (_ctx.noMixedMessage)
                ? (_openBlock(), _createBlock(_component_app_no_message, {
                    key: 1,
                    icon: _ctx.noMixedMessage.icon
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.noMixedMessage.text), 1)
                    ]),
                    _: 1
                  }, 8, ["icon"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["modelValue", "onRefresh", "successText", "pullingText", "loosingText", "loadingText", "disabled"])
        ], 544))
      : (_openBlock(), _createElementBlock("div", {
          key: 2,
          class: "scroll",
          ref: "scroller",
          onScroll: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.handleScroll && _ctx.handleScroll(...args)))
        }, [
          (_ctx.isOverDropZone)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_7))
            : _createCommentVNode("", true),
          _createVNode(_component_item_mixed, {
            onViewFile: _ctx.openFile,
            mixedList: _ctx.mixedData,
            column: !_ctx.driveStore.isGridFolderView,
            skeleton: _ctx.dataLoading,
            selector: _ctx.driveStore.isMixedSelector,
            loading: _ctx.isPageLoading
          }, null, 8, ["onViewFile", "mixedList", "column", "skeleton", "selector", "loading"]),
          (!_ctx.dataLoading && _ctx.noMixedMessage && !_ctx.driveStore.mixedData.data)
            ? (_openBlock(), _createBlock(_component_app_no_message, {
                key: 1,
                icon: _ctx.noMixedMessage.icon
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.noMixedMessage.text), 1)
                ]),
                _: 1
              }, 8, ["icon"]))
            : _createCommentVNode("", true)
        ], 544))
  ]))
}